<template>
    <!--食堂日常考核表单-->
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="日常考核" lefttext="返回" @leftclick="togo('/application/canteen/assessment')"></my-top>
            <Form ref="form">
                <cell :title="'单位：'+form.unitName"></cell>
                <cell v-for="(item, n) in form.topics" :key="n">
                    <template #title>{{item.topicName}}</template>
                    <template #label>
                        <field name="checkboxGroup" v-if="item.type === 'checkbox'">
                            <template #input>
                                <checkbox-group v-model="item.ids" @change="handleChange()">
                                    <div @click="toggle(n, k)"  v-for="(items, k) in item.options">
                                        <checkbox shape="square"
                                                  @click="handleClick(item, items)"
                                                  ref="checkboxes"
                                                  :disabled="disabled"
                                                  :name="items.id || n+'-'+k"
                                                  :key="n+'-'+k" >{{items.optionsName}}</checkbox>
                                    </div>
                                </checkbox-group>
                            </template>
                        </field>
                        <div class="formCtn" v-else-if="item.type === 'textarea'">
                            <field v-model="item.options[0].optionsName"
                                   rows="2"
                                   autosize
                                   show-word-limit
                                   type="textarea"
                                   maxlength="300"
                                   :disabled="disabled"
                                   placeholder="请输入" @input="handleChange()"/>
                        </div>
                        计分规则：{{item.calScore}}
                    </template>
                </cell>
                <cell title="9，照片">
                    <template #label>
                        <UploadList :imageList="form.fileInfoVOS"
                                    v-on:imageListChange="qualifiedImgListChange($event)"
                                    v-on:handleUploadStatus="UploadStatusChange($event, i)"></UploadList>
                        <div v-if="UploadError" style="color: #f00">请上传图片</div>
                    </template>
                </cell>
                <cell :title="'总分：'+form.totalScore"></cell>
            </Form>
        </div>
        <div class="btnSub" v-if="!disabled">
            <van-button block type="info" :loading="loadingSub" loading-text="提交中..."  @click="handleValidate">提交</van-button>
        </div>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Checkbox, CheckboxGroup, Dialog, Field, Form, Loading} from "vant";
    import UploadList from "@components/UploadListVant/index.vue";
    import application from '@api/application';

    export default {
        name: "canteenAssessmentForm",
        components: {Cell, Form, CellGroup, Field, Button, Loading,CheckboxGroup,Checkbox,UploadList,Dialog},
        data() {
            return {
                checkboxGroup: [],
                UploadError:false,
                uploadStatus:false, //图片上传状态
                loadingSub:false,
                disabled:this.$route.query.disabled || false,
                listId:this.$route.query.listId,
                fileId: [], //文件ID,多个使用,隔开
                form:{
                    unitId: JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    unitName: JSON.parse(localStorage.getItem("vuex")).user.company.name,
                    fileInfoVOS:[],
                    totalScore:'', //总分
                    topics:[
                        {
                            type: 'checkbox',
                            topicName: '1, 整理', //题目
                            calScore: '此项共7分', //分值计算规则
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: '0', // 1是， 0否
                                    score: 2,
                                    optionsName: '食堂餐厅、包间、桌面地面垃圾或其他无废弃杂物（2分)',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂操作间、清洗区、仓库等无废弃物杂物（3分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '过道通畅，无物品堵塞（2分）',
                                },
                            ]
                        },{
                            type: 'checkbox',
                            topicName: '2, 整顿',
                            calScore: '此项共10分',
                            optionsScore: '',
                            options:[
                                {
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂各区域都有明确标识，且按标识使用各区域（3分） ',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂各类物品分类别按规定位置摆放整齐，且有相应标识（3分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '菜类食品放置干净区域，且新鲜、无不清洁、变质食品（2分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '冰箱、冰柜等内外保存清洁，生熟食品分开存放，存放食品每周至少解冻清理一次（2分）',
                                },
                            ]
                        },{
                            type: 'checkbox',
                            topicName: '3, 清扫', //题目
                            calScore: '此项共9分',
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: '0',
                                    score: 2,
                                    optionsName: '食堂、餐厅、包间、桌椅、地面、墙面有专人定时打扫（2分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂操作间原料区清洗区有经常打扫，各台、架、面清洁无油腻，厨房炉灶用的铁锅及手勺、锅铲、菜筐等用具洁净（3分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '吸排油烟罩除每天开完晚餐清洗里面外，厨房灶头喷火嘴每半月拆洗一次（2分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '厨房冰库每周彻底清洁冲洗整理一次；干货库房每周盘点时清洁整理一次；厨房屋顶天花板每月清扫一次（2分）',
                                },
                            ]
                        },{
                            type: 'checkbox',
                            topicName: '4, 清洁', //题目
                            calScore: '此项共11分',
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂工作人员能及时清扫所属保洁区域、处理生活垃圾，食堂餐厅经常打扫，桌椅、地面、墙面及天花板无油渍、无蜘蛛网（3分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '餐具、用具及时清洗，餐具类严格按要求高温消毒（2分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '食堂有明确文字规定食品、清洁等流程，且严格遵照执行（2分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '供餐台在供餐前清洁卫生，供餐期间随时清理散漏的菜饭并收集放入剩菜桶，保持供餐台清洁（2分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '食堂无苍蝇、蚂蚁、蟑螂、老鼠等（2分）',
                                },
                            ]
                        },
                        {
                            type: 'checkbox',
                            topicName: '5, 安全', //题目
                            calScore: '此项共31分',
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: '0',
                                    score: 2,
                                    optionsName: '食堂工作人员能自觉按要求带工作防护工具（2分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '配备消防设施，员工熟练使用食堂消防设施、设备（3分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂工作人员即时保修故障设施设备，确保设备正常运转（3分）',
                                },{
                                    choose: '0',
                                    score: 4,
                                    optionsName: '个人需办理健康证并保证健康证有效，有疾病应及时报告办公室管理人员，如有传染病或皮肤病不得上岗（4分）',
                                },{
                                    choose: '0',
                                    score: 4,
                                    optionsName: '留样食品按品种分别盛放在密闭专用容器内，在冷藏条件下存放48小时（4分）',
                                },{
                                    choose: '0',
                                    score: 4,
                                    optionsName: '食堂区域严禁吸烟（4分）',
                                },{
                                    choose: '0',
                                    score: 5,
                                    optionsName: '是否有腐烂、变质和超过保质期限的食品入库（5分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂盛器、容器、食品等不得着地存放（3分）',
                                },{
                                    choose: '0',
                                    score: 1,
                                    optionsName: '刀具、工具是否放在指定位置（1分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '保密安全，来访客人信息严禁打听、外传（2分）',
                                },
                            ]
                        },
                        {
                            type: 'checkbox',
                            topicName: '6, 节约', //题目
                            calScore: '此项共20分',
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: '0',
                                    score: 4,
                                    optionsName: '食堂工作人员应预算好所需食品蔬菜，避免浪费（4分）',
                                },{
                                    choose: '0',
                                    score: 4,
                                    optionsName: '食堂工作人员应合理使用粮油蔬菜，避免浪费（4分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '食堂工作人员应合理储存粮油蔬菜，避免腐败（3分）',
                                },{
                                    choose: '0',
                                    score: 4,
                                    optionsName: '下班关闭所有设备及用电设施（冰箱、冰柜除外）（4分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: '食堂工装人员礼貌工作，态度和蔼、文明用语、无争吵现象（2分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '工作期间不戴戒指、男员工不得留长发、不留胡须，女员工头发应用工帽扎好，不得留长指甲涂指甲油（3分）',
                                },
                            ]
                        },
                        {
                            type: 'checkbox',
                            topicName: '7, 素养', //题目
                            calScore: '此项共7分',
                            optionsScore: '', //得分
                            options:[
                                {
                                    choose: '0',
                                    score: 2,
                                    optionsName: '工作期间按规定穿好工装、戴好工帽，工装衣着必须挺刮、整齐，无黑斑、无大块油迹，工作服经常更换（2分）',
                                },{
                                    choose: '0',
                                    score: 3,
                                    optionsName: '工作前清洁双手，供餐时须戴好口罩和卫生手套（3分）',
                                },{
                                    choose: '0',
                                    score: 2,
                                    optionsName: ' 定期开展调查问卷，听取员工意见，改进食堂工作（2分）',
                                },
                            ]
                        },
                        {
                            type: 'textarea',
                            topicName: '8, 其他', //题目
                            calScore: '此项共5分',
                            optionsScore: '', //得分
                            options:[{
                                choose: '0',
                                score: 5,
                                optionsName:''
                            }]
                        }
                    ]
                },
            }
        },
        methods:{
            /**
             * 改变选项计算总分
             **/
            handleChange(e){
                if(this.disabled){
                    return false
                }
                let score =0 ;
                this.form.topics.map(item => {
                    if(item.type === 'checkbox'){
                        item.options.map(items => {
                            // 选择加分
                            if(items.choose === '1'){
                                score += items.score
                            }
                        });
                        item.optionsScore = score; //获得选项总分
                    }else if(item.type === 'textarea' && item.options[0].optionsName){
                        score += item.options[0].score;
                    }
                });
                this.form.totalScore = score;
            },
            handleClick(item, items){
                if(items.choose === '0'){
                    items.choose = '1'
                }else if (items.choose === '1'){
                    items.choose = '0'
                }
            },
            /**
             * 验证
             **/
            handleValidate(){
                if(this.form.totalScore<=0){
                    this.$toast('请进行考核打分');
                    return false
                }
                Dialog.confirm({
                    message: '请确认是否要提交，提交后不可修改。',
                }).then(() => {
                    this.handleSubmit()
                })
            },
            /**
             * 提交
             **/
            handleSubmit(){
                this.loadingSub = true;
                application.addCanteenAssessment(this.form).then(res=>{
                    if(res.code == 0){
                        this.$router.push({
                            path: '/application/canteen/assessment',
                        })
                    }
                    this.loadingSub = false;
                }).catch(err => {
                    this.$toast('请稍后再试！');
                    this.loadingSub = false;
                })
            },
            toggle(n, k) {
                if(this.disabled){
                    return false
                }
                let index = 0;
                for(let i=0; i<n; i++){
                    index += this.form.topics[i].options.length;
                }
                index += k;
                this.$refs.checkboxes[index].toggle();
            },
            /**
             * 完成图片
             * @param $event
             */
            qualifiedImgListChange($event) {
                this.form.fileInfoVOS = $event;
                if(this.form.fileInfoVOS){
                    this.UploadError = false
                }
                this.fileId = $event.map((item) => {
                    return item.commonId;
                });
                this.uploadStatus=false
            },

            //上传图片状态
            UploadStatusChange($event, i){
                this.uploadStatus=$event;
            },
            handleCanteenAssessment(){
                application.getCanteenAssessment({id:this.listId}).then(res => {
                    if(res.code == 0){
                        this.form = res.data
                    }
                }).catch(err => {

                })
            }
        },
        mounted() {
            if(this.disabled){
                this.handleCanteenAssessment()
            }
        }
    }
</script>

<style  lang="scss" scoped>
    .navbar{
        border-bottom: 1px solid #f5f5f5;
    }
    .view{
        background: #FFFFFF;
        height: calc(100vh + 1px);
        .content{
            padding-bottom: 5rem;
            .van-cell-group__title{
                color: #333333;
                /*background-color: #f5f5f5;*/
            }
        }
        .cellgroup.van-hairline--top-bottom::after{
            border:none
        }
        .van-checkbox-group>div{
            margin-bottom: 10px;
        }
        ::v-deep .van-checkbox{
            align-items: flex-start;
        }
        ::v-deep .van-checkbox__label{
            margin-top: -1px;
        }
        .formCtn{
            padding: 0 0 1rem;
            border-bottom: 0.1rem solid #f5f6f7;
            .van-field {
                padding: 0;
                &.van-cell--required::before {
                    z-index: 2;
                }
            }
            ::v-deep .van-field__value{
                background-color: #f2f2f2;
                border-radius: 4px;
                padding: 1rem 1rem 1rem 1.6rem;
            }
            ::v-deep .van-field--error .van-field__control, .van-field--error .van-field__control::placeholder{
                background-color: #FFF9E8;
            }
            ::v-deep .van-field--error .van-field__value{
                background-color: #FFF9E8;
            }
        }
        .btn{
            .van-button{
                padding: 0;
                margin: 0;
                border-radius: 99px;
            }

        }

    }
</style>